<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 顶部统计区块 -->
    <div class="index-block-top">
      <div class="index-top-left">
        <div style="margin-top: 60px">
          <el-image :src="img" style="height: 80px"> </el-image>
        </div>
        <div
          style="
            font-size: 14px;
            line-height: 40px;
            margin-top: 10px;
            font-weight: bold;
          "
        >
          {{ infoData.name }}
        </div>
        <div style="font-size: 12px; line-height: 30px">
          展位号：
          <span style="font-size: 16px; font-weight: bold">
            {{infoData.booth}}</span>
        </div>
      </div>
      <div class="index-top-right">
        <div class="index-stats">
          <div class="index-stats-ranking">
            <div style="font-size: 40px; color: #2a36b1; margin-top: 40px">
              {{ ranking.ranking }}
            </div>
            <div style="font-size: 14px; color: var(--text-primary); line-height: 30px">
              人气排名
            </div>
            <div style="font-size: 12px; color: var(--text-primary)">按预约人数统计</div>
          </div>
          <div class="index-stats-detail">
            <el-row>
              <el-col :span="6">
                <div style="font-size: 40px; color: #2a36b1; margin-top: 40px">
                  {{ infoData.invitation }}
                </div>
                <div style="font-size: 14px; color: var(--text-primary); line-height: 30px">
                  预约人数
                </div>
              </el-col>
              <el-col :span="6">
                <div style="font-size: 40px; color: #2a36b1; margin-top: 40px">
                  {{ infoData.praise }}
                </div>
                <div style="font-size: 14px; color: var(--text-primary); line-height: 30px">
                  点赞数
                </div>
              </el-col>
              <el-col :span="6">
                <div style="font-size: 40px; color: #2a36b1; margin-top: 40px">
                  {{ infoData.view }}
                </div>
                <div style="font-size: 14px; color: var(--text-primary); line-height: 30px">
                  浏览数
                </div>
              </el-col>
              <el-col :span="6">
                <div style="font-size: 40px; color: #2a36b1; margin-top: 40px">
                  {{ infoData.share }}
                </div>
                <div style="font-size: 14px; color: var(--text-primary); line-height: 30px">
                  转发数
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部内容区块 -->
    <div class="index-block-bottom">
      <!-- 展会信息卡片 -->
      <div class="index-bottom-left">
        <div class="new-image">
          <el-image
            src="/static/img/index_bg.png"
            fit="fill"
          ></el-image>
        </div>
        <div class="new-title">
          {{ showData.title }}
        </div>
        <div class="new-time">
          <span style="font-weight: bold">举办时间：</span>
          {{ showData.exhibition_time }}
        </div>

        <div class="new-address">
          <span style="font-weight: bold"> 举办地址：</span>
          {{ showData.address }}
        </div>
        <div style="margin: 20px 0">
          <el-row>
            <el-button
              round
              @click="go_detailId"
              style="
                border: 1px solid rgba(42, 54, 177, 1);
                color: rgba(42, 54, 177, 1);
              "
              >了解展会详情
            </el-button>
          </el-row>
        </div>
      </div>

      <!-- 最新信息卡片 -->
      <div class="index-bottom-right">
        <div class="right-title">
          <div class="right-new-title">展会最新信息</div>
          <div class="right-new-more" @click="go_ex">查看更多 ></div>
        </div>

        <!-- 数据表格 -->
        <div style="padding: 20px">
          <el-table
            :data="tableData"
            @row-click="to_infoDetail"
            style="width: 100%"
          >
            <el-table-column prop="create_time" label="日期" > </el-table-column>
            <el-table-column prop="title" label="标题"> </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "index",
  data() {
    return {
      imgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/logo/",
      infoData: [],
      tableData: [],
      showData: [],
      ranking: "",
      img: "",
    };
  },
  mounted() {
    this.getinfo();
    this.newDataList();
    this.showDataList();
  },
  methods: {
    /** 获取用户信息及排名 */
    getinfo() {
      let id = localStorage.getItem("userid");
      let url = this.baseUrl + "/user/users/" + id + "/";
      api.fetchData(url).then((res) => {
        this.infoData = res;
        this.img = this.imgUrl + this.infoData.logo;
      });

      let url2 = this.baseUrl + "/user/top/" + id + "/";
      api.fetchData(url2).then((res) => {
        this.ranking = res;
      });
    },
    /** 获取最新资讯列表 */
    newDataList() {
      let url = this.baseUrl + "/user/news/?ordering=-create_time&size=4";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
      });
    },
    /** 获取展会配置信息 */
    showDataList() {
      let url = this.baseUrl + "/user/config/";
      api.fetchData(url).then((res) => {
        this.showData = res[0];
      });
    },

    /** 跳转到资讯详情页 */
    to_infoDetail(row) {
      let id = row.id;
      this.$router.push({ name: "infoDetail", query: { id: id } });
    },
    /** 跳转到展会详情页 */
    go_detailId: function () {
      this.$router.push({ name: "exhibitionDetail"});
    },
    /** 跳转到展会信息列表页 */
    go_ex() {
      this.$router.push({ name: "exhibitionList" });
    },
  },
};
</script>

<style scoped>
.index-block-top {
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.index-block-bottom {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin: 20px 0;
  width: 100%;
  min-height: 346px;
}

.index-top-left {
  width: 300px;
  min-height: 300px;
  background-color: white;
  border-radius: 20px;
  flex-shrink: 0;
}

.index-top-right {
  flex: 1;
  min-width: 300px;
  min-height: 300px;
  background-color: white;
  border-radius: 20px;
  overflow: hidden;
}

.index-stats {
  margin: 50px 0;
  display: flex;
}

.index-stats-ranking {
  width: 238px;
  height: 180px;
  border-right: 1px dashed var(--border-color);
}

.index-stats-detail {
  flex: 1;
  height: 180px;
}

.index-bottom-left {
  width: 300px;
  min-height: 346px;
  background-color: white;
  border-radius: 20px;
  flex-shrink: 0;
}

.index-bottom-right {
  flex: 1;
  min-width: 300px;
  min-height: 346px;
  border-radius: 20px;
  background-color: white;
  overflow: hidden;
}

.new-image {
  padding: 16px;
  width: 268px;
}

.new-title {
  width: 268px;
  line-height: 32px;
  font-size: 15px;
  font-weight: bold;
  padding: 0 16px;
  text-align: left;
}

.new-time {
  width: 268px;
  text-align: left;
  font-size: 14px;
  line-height: 30px;
  padding: 0 16px;
}

.new-address {
  width: 268px;
  text-align: left;
  font-size: 14px;
  line-height: 30px;
  padding: 0 16px;
}

.right-title {
  height: 60px;
  line-height: 60px;
  padding: 0 20px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
}

.right-new-title {
  font-weight: bold;
  font-size: 15px;
}

.right-new-more {
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/index.vue